import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ICompanyGroupFeature } from './company-group.feature.state';
import { getCompanyGroup, getFailures, getIsLoading } from './company-group.selectors';
import {
  ClearStateAction,
  getCompanyGroupAction,
  getCompanyGroupBySubDomainAction,
  getCompanyGroupSuccessAction,
} from './company-group.actions';
import { CompanyGroupRequest } from '../models';
import { filter, first, map } from 'rxjs/operators';
import { AppConfigService, CompanyGroupService } from '../services';
import { Observable } from 'rxjs';
import { NavController } from '@ionic/angular';
import { ENDED } from '@symphony-solo/shared/utils/src';

@Injectable()
export class CompanyGroupFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public getCompanyGroup$ = this.store.select(getCompanyGroup).pipe(filter((companyGroup) => !!companyGroup));
  public companyGroupInfo$ = this.store.select(getCompanyGroup);

  constructor(
    private store: Store<ICompanyGroupFeature>,
    private appConfigService: AppConfigService,
    private companyGroupService: CompanyGroupService,
    private navCtrl: NavController
  ) {}

  public getCompanyGroup(payload: CompanyGroupRequest): void {
    this.store.dispatch(getCompanyGroupAction({ CompanyGroupRequest: payload }));
  }

  public setCompanyGroup(payload) {
    this.store.dispatch(getCompanyGroupSuccessAction(payload));
  }

  public getCompanyGroupBySubDomain() {
    const subdomain = this.companyGroupService.getDominHost();
    this.store.dispatch(getCompanyGroupBySubDomainAction({ subdomain }));
  }

  public getCompanyGroupLocal() {
    const companyData = localStorage.getItem('COMPANY_DATA');
    if (companyData) {
      this.appConfigService.setConfig(JSON.parse(companyData));
    }
  }

  public getCompanyToken(): Observable<any> {
    return this.store.select(getCompanyGroup).pipe(
      map((tokenResult) => tokenResult),
      first()
    );
  }

  public async getsubdmainCompany(saveToLocal = true) {
    const company = await this.companyGroupService.getCompanyGroupDomain(this.companyGroupService.getDominHost()).toPromise();

    if (saveToLocal) {
      this.setCompanyGroup({ CompanyGroup: company });
      localStorage.setItem('COMPANY_DATA', JSON.stringify(company));
    }

    if (company['enabled'] === false) {
      this.serviceEnded();
    }
    return company;
  }

  public serviceEnded() {
    this.companyGroupService.clearData();
    this.navCtrl.navigateForward(ENDED);
    return false;
  }

  public clearState(actionType: string): void {
    this.store.dispatch(ClearStateAction({ actionType }));
  }
}
